const opportunitiesLang = {
  params: {
    menuParent: 'Opportunités',
    menu: 'Paramètres',
    pageTitle: 'Paramètres des opportunités',
    allowAllCustomer: 'Permettre de rattacher des documents dont le client ne correspond pas à l\'opportunité',
    linkedDocumentTitle: 'Affichage des documents liés sur la fiche opportunité :',
    linkedDocumentShowTitle: 'Afficher le titre du document',
    linkedDocumentShowDateAmount: 'Afficher la date et le montant du document',
    referenceTitle: 'Numérotation des opportunités',
    referencePrefix: 'Préfixe',
    referenceNextNumber: 'Prochain numéro',
    referenceTypeNumber: 'Type de numérotation',
    referenceLength: 'Nombre de chiffre',
    referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
    referenceYear4: 'l\'année sur 4 chiffres',
    referenceYear2: 'l\'année sur 2 chiffres',
    referenceMonth: 'le mois',
    referenceDay: 'le jour',
    referenceMode0: 'Normal',
    referenceMode1: 'Remise à 0 tous les mois',
    referenceMode2: 'Remise à 0 tous les ans',
  },
  funnels: {
    menu: 'Tunnels de vente',
    pageTitle: 'Gestion des tunnels de vente',
    createTitle: 'Création d\'un tunnel de vente',
    updateTitle: 'Modification d\'un tunnel de vente',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce tunnel de vente ?',
    deleteAlertMessage: 'Attention, toutes les opportunités rattachées au tunnel de vente seront supprimées.',
    name: 'Nom du tunnel de vente',
    stepsTitle: 'Étapes ({nb})',
    stepName: 'Nom',
    stepProbability: 'Probabilité',
    noStep: 'Aucune étape',
    addStep: 'Ajouter une étape',
    categoriesTitle: 'Catégories ({nb})',
    categoryExplain: 'Les catégories peuvent être appliquées aux différentes opportunités du tunnel de vente.',
    categoryName: 'Nom',
    categoryColor: 'Couleur',
    noCategory: 'Aucune catégorie',
    addCategory: 'Ajouter une catégorie',
    restrictionsTitle: 'Restrictions',
    restrict: 'Restreindre l\'accès au tunnel de vente',
    restrictUser: 'Utilisateur(s) ayant accès au tunnel de vente',
    automaticStatus: 'Passer automatiquement l\'opportunité au statut',
    hideWin: 'Masquer les opportunitées gagnées au bout de',
    hideLose: 'Masquer les opportunitées perdues au bout de',
    hideCancel: 'Masquer les opportunitées annulées au bout de',
    hideDays: 'jour(s)',
    deleteStepAlert: 'Attention, la suppression de l\'étape entrainera la <strong>suppression de toutes les opportunités</strong> utilisant cette étape.'
  },
  funnel: {
    pageTitle: 'Tunnel de vente',
    menu: 'Tunnel de vente',
    label: 'Tunnel de vente',
    filters: 'Filtres',
    commercials: 'Commerciaux',
    allCommercials: 'Tous les commerciaux',
    categories: 'Catégories',
    allCategories: 'Toutes les catégories',
    status: 'Statuts',
    allStatus: 'Tous les statuts',
    deadline: 'Échéance',
    noDeadline: 'Aucune échéance',
    deadlineAt: 'Échéance au {date}',
    deadlinePassedSince: 'Échéance dépassée depuis le {date}',
    nextTask: 'Prochaine tâche : {title}',
    see: 'Voir',
    noFunnel: 'Vous n\'avez aucun tunnel de vente',
    create: 'Créer un tunnel de vente'
  },
  opportunities: {
    menu: 'Opportunités',
    label: 'Opportunité',
    reference : 'Opportunité n°{reference}',
    pageTitle: 'Liste des opportunités',
    newBtn: 'Nouvelle opportunité',
    createBtn: 'Créer une opportunité',
    addTitle: 'Création d\'une opportunité',
    editTitle: 'Modification d\'une opportunité',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette opportunité ?',
    documentType: 'Type de document',
    documentAttachExplain: 'Lorsqu\'un document est rattaché, tous ses documents liés seront automatiquement rattachés, incluant ceux qui seront créés ultérieurement.',
    attach: 'Rattacher',
    documentAttach: 'Rattacher un document',
    removeAttach: 'Supprimer le rattachement des documents',
    removeAttachMsg: 'Êtes-vous sûr de vouloir supprimer ce rattachement ?',
    nbForAmount: '{length} opportunités pour {amount}',
    form: {
      title: 'Titre',
      description: 'Description de l\'opportunité',
      funnel: 'Tunnel',
      step: 'Étape',
      category: 'Catégorie',
      amount: 'Montant estimatif',
      expire: 'Date d\'échéance',
      probability: 'Probabilité',
      commercial: 'Commercial',
      lossTitle: 'Perte de l\'opportunité',
      lossReason: 'Motif de perte de l\'opportunité :',
      lossComments: 'Commentaires :',
      pass: 'Passer'
    },
    list: {
      reference: 'N° opportunité',
      title: 'Titre',
      customer: 'Client',
      contact: 'Contact',
      amount: 'Montant',
      probability: 'Probabilité',
      status: 'Statut',
      expireAt: 'Échéance',
      category: 'Catégorie',
      step: 'Étape',
      funnel: 'Tunnel de vente',
      quotationCa: 'Devis - CA',
      quotationCosts: 'Devis - Coûts',
      quotationMargin: 'Devis - Marge',
      quotationValidCa: 'Devis acceptés - CA',
      quotationValidCosts: 'Devis acceptés - Coûts',
      quotationValidMargin: 'Devis acceptés - Marge',
      commandCa: 'Bons de commande - CA',
      commandCosts: 'Bons de commande - Coûts',
      commandMargin: 'Bons de commande - Marge',
      proformaCa: 'Factures Proforma - CA',
      proformaCosts: 'Factures proforma - Coûts',
      proformaMargin: 'Factures proforma - Marge',
      deliveryCa: 'Bons de livraison - CA',
      deliveryCosts: 'Bons de livraison - Coûts',
      deliveryMargin: 'Bons de livraison - Marge',
      invoiceCa: 'Factures - CA',
      invoiceCosts: 'Factures - Coûts',
      invoiceMargin: 'Factures - Marge',
      creditCa: 'Avoirs - CA',
      creditCosts: 'Avoirs - Coûts',
      creditMargin: 'Avoirs - Marge',
      salesCa: 'Ventes - CA',
      salesCosts: 'Ventes - Coûts',
      salesMargin: 'Ventes - Marge',
      commercial: 'Commercial',
      winnedAt: 'Date gagnée',
      losedAt: 'Date perdue',
      cancelledAt: 'Date annulée',
      createdAt: 'Date de création',
      updatedAt: 'Date de modification',
      lossReason: 'Motif de perte',
      lossReasonComments: 'Commentaires sur la perte'
    },
    item: {
      genericPageTitle: 'Fiche opportunité',
      pageTitle : 'Opportunité n°{reference}',
      new: 'Nouveau',
      status: 'Statut',
      step: 'Étape',
      customer: 'Client',
      contact: 'Contact',
      description: 'Description',
      winnedAt: 'Date gagnée',
      losedAt: 'Date perdue',
      lossReason: 'Motif de perte',
      lossReasonComments: 'Commentaires sur la perte',
      canceledAt: 'Date annulée',
      linkedDocuments: 'Documents liés',
      amountQuoted: 'Montants devisés',
      ca: 'CA',
      margin: 'Marge',
      costs: 'Coûts',
      acceptedQuotation: 'Devis acceptés',
      amountInvoiced: 'Montants facturés',
      element: 'Élément'
    },
    status: {
      1: 'En cours',
      2: 'Gagnée',
      3: 'Perdue',
      4: 'Annulée'
    }
  },
  lossReasons: {
    createTitle: 'Création d\'un motif de perte',
    updateTitle: 'Modification d\'un motif de perte',
    deleteMsg: 'Suppression d\'un motif de perte',
    label: 'Motif de perte',
    pageTitle: 'Gestion des motifs de perte',
    menu: 'Motifs de perte'
  }
}

const tasksLang = {
  searchTypes: {
    opportunity: 'Opportunité'
  }
}

const calendarsLang = {
  searchTypes: {
    opportunity: 'Opportunité'
  }
}

export default {
  opportunities: opportunitiesLang,
  tasks: tasksLang,
  calendars: calendarsLang
}
